import * as React from 'react';
import Basic from '../_layout';
import generator from '../_layout/util';

const Layout = generator({
  prefixCls: 'mkui-layout-drawer',
})(Basic);

const Content = generator({
  prefixCls: 'mkui-layout-drawer-content',
})(Basic);

const Footer = generator({
  prefixCls: 'mkui-layout-drawer-footer',
})(Basic);

Layout.Content = Content;
Layout.Footer = Footer;
export default Layout;
